// extracted by mini-css-extract-plugin
export var chevronIcon = "_ck-2";
export var teamName = "_ck-1";
export var teamSwitcherButton = "_ck-0";